import { Button, Col, Form, Input, message, Row } from "antd";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { PropagateLoader } from "react-spinners";
import { signInWithEmailAndPassword } from "firebase/auth";
import { toast } from "react-hot-toast";
import axios from "axios";

const Login = () => {
  const [user, loading, error] = useAuthState(auth);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const onFinish = async (values) => {
    setIsSubmitted(true);
    
    try {
      const userData = {
        email: values.email,
        password: values.password,
      };
      try {
        const response = await axios.post(
          "https://us-central1-sayeagle-77c75.cloudfunctions.net/api/mananger_portal_login",
          userData
        );

        await signInWithEmailAndPassword(auth, values.email, values.password);
        console.log(response.data); // User created successfully
        toast.success("Login created successfully.");
        navigate("/");
      } catch (error) {
        console.error("Error creating user:", error);
        const errorMessage = error.message;
        toast.error(
          errorMessage === "Request failed with status code 403"
            ? "Access denied"
            : "User not found"
        );
        setIsSubmitted(false);

      }
    } catch (error) {
      const errorMessage = error.message;
      toast.error(errorMessage);
      setIsSubmitted(false);
    }
  };
  const onFinishFailed = () => {
    toast.error(
      "All fields are required. Please fill in all the required information."
    );
    setIsSubmitted(false);
  };

  const navigate = useNavigate();

  useEffect(() => {
    if (!loading) {
      setIsLoading(false);
    }
    if (user) {
      navigate("/");
      setIsLoading(false);
    }
  }, [user, loading]);
  return (
    <div>
      {isLoading ? (
        <PropagateLoader color="#006eb7" size={5} className="loadingSpinner" />
      ) : (
        <Row>
          <Col xs={24} md={10} lg={10}>
            <div className="leftSide">
              <h1 className="companyTitle">SayEagle</h1>
              <h3 className="userLoginType">Property Manager</h3>
            </div>
          </Col>
          <Col xs={24} md={14} lg={14}>
            <div className="rightSide">
              <h3 className="titlePage">Login</h3>

              <Form
                name="basic"
                initialValues={{
                  remember: true,
                  totalUnits: {
                    number: 0,
                  },
                }}
                layout="vertical"
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
                style={{
                  maxWidth: 500,
                  width: "100%",
                }}
              >
                <Form.Item
                  label="Email Address"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Email Address!",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>

                <Form.Item
                  label="Password"
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Please input your Password!",
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ width: "100%" }}
                    loading={isSubmitted}
                  >
                    {isSubmitted ? "please wait..." : "Login"}
                  </Button>
                </Form.Item>
              </Form>
              <Link to="/reset">Forgot your password?</Link>
              <span>
                Don't have an account? <Link to="/register">Register</Link> now.
              </span>
            </div>
          </Col>
        </Row>
      )}
    </div>
  );
};

export default Login;
